
import travcalnLogo from './assets/images/travclan-logo-new.png';
export const BUILD_TYPE = process.env.REACT_APP_BUILD_TYPE;

export const TRAVCLAN_LOGO = travcalnLogo; //process.env.NODE_ENV == "production" ? '/websitechat/travclan-logo-new.png' :  '/travclan-logo-new.png'
export const API_DOMAIN_URL = process.env.REACT_APP_API_DOMAIN_URL;
export const API_DOMAIN_URL_v1 = process.env.REACT_APP_API_DOMAIN_URL_v1;
export const API_DOMAIN_LIVE = process.env.REACT_APP_API_DOMAIN_LIVE;
export const API_DOMAIN_v1 = process.env.REACT_APP_API_DOMAIN_v1;
export const API_DOMAIN_CMS = process.env.REACT_APP_API_DOMAIN_CMS;
export const API_DOMAIN_AMP = process.env.REACT_APP_API_DOMAIN_AMP;
export const API_DOMAIN_B2B2C = process.env.REACT_APP_API_DOMAIN_B2B2C;
export const API_DOMAIN_B2B2C_QA = process.env.REACT_APP_API_DOMAIN_B2B2C_QA;
export const API_DOMAIN_URL_RESELLER =
  process.env.REACT_APP_API_DOMAIN_URL_RESELLER;
export const API_DOMAIN_TRAVPAY = process.env.REACT_APP_API_DOMAIN_TRAVPAY;
export const API_DOMAIN_FLIGHTS = process.env.REACT_APP_API_DOMAIN_FLIGHTS;
export const API_DOMAIN_URL_v3 = process.env.REACT_APP_API_DOMAIN_URL_v3;
export const FLIGHT_SEARCH_ASSETTAG =
  process.env.REACT_APP_FLIGHT_SEARCH_ASSETTAG;
export const HOTELS_SEARCH_ASSETTAG =
  process.env.REACT_APP_HOTELS_SEARCH_ASSETTAG;
export const API_DOMAIN_KUBER = process.env.REACT_APP_API_DOMAIN_KUBER;
export const FLIGHTS_TRAVPAY_CALLBACK_URL = "flights/book/";
export const TRAVPAY_FLIGHTS_MERCHANT_CODE =
  process.env.REACT_APP_TRAVPAY_FLIGHTS_MERCHANT_CODE;
export const REMIT_KUBER_MERCHANT_CODE =
  process.env.REACT_APP_REMIT_KUBER_MERCHANT_CODE;
export const LEO_CAPTCHA_SITE_KEY = process.env.REACT_APP_CAPTCHA_SITE_KEY;
export const PRODUCT_OPTION_TRAVCLAN_FLIGHT = "tc_flight";
export const PRODUCT_OPTION_B2B2C_FLIGHT = "ta_flight";

export const API_SECTION_FLIGHT_VERSION = "api/v1/";
export const API_SECTION_BOOKING_VERSION = "api/v1/";
export const API_SECTION_PUBLIC = "public/";
export const API_SECTION_RESELLER_LISTINGS = "public-api/v1/";
export const API_SECTION_RESELLER_LISTINGS_V2 = "public-api/v2/";
export const API_DOCSUMO_PAN = "https://panapi.docsumo.com/api/v1/pan/extract/"; //?base_encode=False
export const API_DOCSUMO_PASSPORT_FRONT =
  "https://passportapi.docsumo.com/api/v1/passport/extract/?side=front"; //?base_encode=False
export const THUMBOR_DOMAIN_URL = "https://assets.travclan.com/unsafe/";
export const APP_CMS_ASSET_URL = "https://app.travclan.com/media/appcms/";
export const RAZZLE_API_LIST_OF_AIRPORTS = `${API_DOMAIN_URL}airports/`;
export const TERMS_AND_CONDITIONS_URL = "https://about.travclan.com/contract";

export const KUBER_PUBLIC_API = "public-api/";
export const KUBER_PRIVATE_API = "private-api/";
export const KUBER_API_VERSION = "v1/";
export const B2B2C_API_PUBLIC_VERSION = "public/v2/";
export const B2B2C_API_VERSION = "v2/";
export const API_ENDPOINT_RESELLER_LISTING = "reseller-listings/";
export const API_ENDPOINT_DOCUMENT_UPLOAD_REQ = "/documents/";
export const API_ENDPOINT_IMAGES_UPLOAD = "/images/";
export const API_ENDPOINT_LEO = "leo/";
export const API_ENDPOINT_AMP_STORIES = "/amp-stories";
export const API_ENDPOINT_CUSTOMER_QUOTES = "customer-quotes/";
export const API_ENDPOINT_PROFILE = "member-profile/";
export const API_ENDPOINT_SEARCH = "search/";
export const API_ENDPOINT_LEAD_GEN_CREATE = "lead_create/";
export const API_ENDPOINT_WEBSITE_DATA = "websitedata/";
export const API_ENDPOINT_ACCOUNTS = "accounts/";
export const API_ENDPOINT_BOOKING_PAY_VERIFY = "booking-payment-verify/";
export const API_ENDPOINT_COLLECT_PAY_VERIFY = "collect-payment-verify/";
export const API_ENDPOINT_CMS_NEWS = "news/";
export const API_ENDPOINT_CMS_LEARN = "category/";
export const API_ENDPOINT_CLICK_TO_CHAT = "click_to_chat/";
export const API_ENDPOINT_WEBSITEPAGES = "websitepages/";
export const API_ENDPOINT_DESTINATIONS = "travsys/destinations/";
export const API_ENDPOINT_ONLY_DESTINATION = "destinations/";
export const API_ENDPOINT_FEATURED_DESTINATION = "featured-destinations/";
export const API_ENDPOINT_COLLECTIONS = "collections/";
export const API_ENDPOINT_AIRPORTS = "travsys/airports/";
export const API_ENDPOINT_CMS_HELP = "assettag/";
export const API_ENDPOINT_CMS_DEALS = "section/";
export const API_ENDPOINT_RESELLER_LISTING_SINGULAR = "reseller-listing/";
export const API_ENDPOINT_RESELLER_LISTING_IMAGES = "reseller-listing-images/";
export const API_ENDPOINT_RESELLER_LISTING_DOCUMENTS =
  "reseller-listing-documents/";
export const API_ENDPOINT_CHATBOT_LEAD = "chatbot-lead/";
export const API_ENDPOINT_SEND = "send/";
export const API_ENDPOINT_ES_SEARCH = "es-search/";
export const API_ENDPOINT_TRAVPAY_ORDER = "order-request/";
export const API_ENDPOINT_MERCHANT_CODE = "merchant-code/";
export const API_ENDPOINT_PAYMENT_LINK = "payment-link/";
export const API_ENDPOINT_PAYMENT_RESPONSE = "payment-mode-rp/";
export const API_ENDPOINT_PAYMENT_PAY_US = "payment-pay-us/";
export const API_ENDPOINT_CUSTOMER_FEEDBACK = "customer-feedback/";
export const API_ENDPOINT_TA_CUSTOMER_FEEDBACK = "ta-customer-feedback/";
export const API_ENDPOINT_POPULAR = "popular/";
export const API_ENDPOINT_RECENT_SEARCHES = "recent-searches";
export const API_ENDPOINT_FARE_RULES = "fare-rules/";
export const API_ENDPOINT_FARE_QUOTE = "fare-quote/";
export const API_ENDPOINT_FLIGHT_BOOK = "book/";
export const API_ENDPOINT_FLIGHT_COUNTRIES = "countries/";
export const API_ENDPOINT_FLIGHT_PASSENGERS = "passenger-collections/";
export const API_ENDPOINT_FLIGHT_PASSENGER = "passenger-collection/";
export const API_ENDPOINT_ITEMS = "items/";
export const API_ENDPOINT_QUOTES_SHARE = "quotes/code/share/";
export const API_ENDPOINT_REQUEST_OTP = "request-otp/";
export const API_ENDPOINT_SIGN_UP = "signup/";
export const API_ENDPOINT_VERIFY_OTP = "verify-otp/";
export const API_ENDPOINT_TRAVPAY_PAYMENT_RP = "payment-rp/";
export const API_ENDPOINT_PAYMENT_STATUS = "payment-status/";
export const API_ENDPOINT_FLIGHT_NOTIFICATION = "send-flight-notification/";
export const API_ENDPOINT_CAPTCHA = "auth/captcha-verify/";
export const API_EDNPOINT_SUPPLIER = "supplier/";
export const API_EDNPOINT_CALCULATE_REMIT_AMT = "calculate-remit-amount/";
export const API_EDNPOINT_REMIT_REQUEST = "remit-request/";
export const API_ENDPOINT_REMIT_TRAVELLER_DOCUMENT = "traveller-document/";
export const API_ENDPOINT_REMIT_TRAVELLER = "traveller/";

export const API_SECTION_KUBER = "kuber/";
export const API_SECTION_LISTINGS = "listings";
export const API_SECTION_HOLIDAYS = "holidays/";
export const API_SECTION_REQUIREMENTS = "requirements";
export const API_SECTION_DEALS = "deals";
export const API_SECTION_UPDATE_FOR_BOT = "update";
export const API_SECTION_REMITT_1 = "bms/bookings/";
export const API_SECTION_CUSTOMER_TAB = "customer-tab/";
export const API_SECTION_CUSTOMER = "customer/";
export const API_SECTION_REMITT_2 = "/remittance-documentation";
export const API_SECTION_REMITT_GETDETAILS = "/traveller-documents";
export const API_SECTION_REMITT_TRAVELERS = "/travellers";
export const API_SECTION_LMS = "lms/";
export const API_SECTION_MEMBERS = "members/";
export const API_SECTION_AUTH = "auth/";
export const API_SECTION_B2B2C = "b2b2c/";
export const API_SECTION_BOOKING_PAYMENTS = "booking-payment/";
export const API_SECTION_COLLECT_PAYMENTS = "collect-payment/";
export const API_SECTION_PAYMENT_INFO = "account-payment-info/";
export const API_SECTION_CMS_NEWS = "news/api/v2/";
export const API_SECTION_CMS_LEARN = "learning/api/";
export const API_SECTION_BOOKING_DETAIL = "booking-details/";
export const API_SECTION_CMS_2 = "cms/";
export const API_SECTION_CMS = "cms/api/";
export const API_SECTION_CMS_DEALS = "deals/api/";
export const API_SECTION_ELASTICSEARCH = "elasticsearch_data/";
export const API_SECTION_PRODUCTS = "products/";
export const API_SECTION_UPDATE = "update/";
export const API_SECTION_NOTIFICATION = "notification/";
export const API_SECTION_CONTENT = "content/";
export const API_SECTION_PAYMENT = "payment/";
export const API_SECTION_MERCHANT = "merchant/";
export const API_SECTION_ACCOUNTS = "accounts/";
export const API_SECTION_FLIGHTS = "b2b2c-flight/";
export const API_SECTION_AIRPORTS = "airports/";
export const API_SECTION_BOOKING = "booking/";
export const API_SECTION_BOOKING_DETAILS = "booking/details/";
export const API_SECTION_FLIGHTS_SEARCH = "flights/";
export const API_SECTION_FLIGHTS_ITENERARY = "itinerary/";
export const API_SECTION_FLIGHT_POSTITENERARY = "post-itinerary/";
export const API_SECTION_FLIGHTS_SHARE = "share/";
export const API_SECTION_AIRPORT_SEARCH = "airport-search/";
export const API_SECTION_MY_BOOKINGS = "mybookings/";
export const API_SECTION_MYBOOKINGS = "my-bookings";
export const API_SECTION_OFFERS = "website-offers";
export const API_ENDPOINT_WEBSITE_GALLERY = "website-gallery/";

export const THEME_WEBSITE_BG_COLOR = "#f1f1f1";
export const THEME_OTHER_SECONDARY_COLOR = "#FBAD23";
export const THEME_BORDER_COLOR = "#BDBDBD";
export const THEME_WHITE_COLOR = "#FFFFFF";
export const API_RESPONSE_UNAUTHORIZED_STATUS = "401";
export const DOCSUMO_APIKEY = process.env.REACT_APP_DOCSUMO_APIKEY;
export const THEME_PRIMARY_COLOR = "#212121"; //'#428bfe'
export const THEME_SECONDARY_COLOR = "#7c3647"; //'#f18d03'
export const THEME_WEBSITE_BLACK_COLOR = "#212121";
export const TOTAL_NEWS_RECOMMENDS_ON_NEWSDETAIL = 3;
export const FLIGHT_CATEGORY = "flight-inventory-slash-blocks";
export const COMMA_FOR_CURRENCY = ["INR"];
export const POWERED_BY_TRAVCLAN_LINK = "https://mysite.travclan.com/";
export const OUTSITE_VR_APIKEY = process.env.REACT_APP_OUTSITE_VR_APIKEY;
export const B2B2C_LISTING_BASE_IMGURL =
  "https://s3.ap-south-1.amazonaws.com/com.travclan.b2b2c/";
export const B2B2C_TRAVPAY_CALLBACK_URL = "/?";
export const TRAVPAY_CLIENT_BASE_URL =
  process.env.REACT_APP_TRAVPAY_CLIENT_BASE_URL;
export const TRAVPAY_CLIENT_WALLET_ENDPOINT = "wallet/add-money";
export const B2B2C_AUTH_PUBLIC_KEY =
  process.env.REACT_APP_B2B2C_AUTH_PUBLIC_KEY;
export const FLIGHTS_AIRLINE_LOGO_BASE_URL =
  "https://assets.travclan.com/unsafe/64x64/smart/https://s3.ap-south-1.amazonaws.com/com.travclan.flight/airline/";

export const PRODUCT_OPTION_TRAVEL_AGENT_WEBSITE_PAY_SAFELY = "ta_pay_safely";
export const PRODUCT_OPTION_TRAVEL_AGENT_BOOKING = "ta_booking";
export const PRODUCT_OPTION_TRAVEL_AGENT_LINK = "ta_link";
export const PRODUCT_OPTION_TRAVEL_AGENT_REMIT = "tc_remit";

export const CUTTLY_URL = "cutt.ly";

export const INCLUSIONS = [
  {
    id: 1,
    name: "Flights",
  },
  {
    id: 2,
    name: "Hotels",
  },
  {
    id: 3,
    name: "Transfers",
  },
  {
    id: 4,
    name: "Sightseeing",
  },
  {
    id: 5,
    name: "VISA",
  },
];

export const UNIT_NAMES = {
  per_person: "Per Person",
  per_night: "Per Night",
  total_net_rate: "Total Net Rate",
};

export const NIGHTCOUNTS = [
  {
    id: "2 - 4 nights",
    name: "2 - 4 nights",
    label: "2 - 4 nights",
    value: "2 - 4 nights",
  },
  {
    id: "5 - 6 nights",
    name: "5 - 6 nights",
    label: "5 - 6 nights",
    value: "5 - 6 nights",
  },
  {
    id: "7 or more nights",
    name: "7 or more nights",
    label: "7 or more nights",
    value: "7 or more nights",
  },
];

export const HOTELRATINGS_SELECT = [
  // {
  //   id: 2,
  //   label: "Budget- 2 Star",
  //   value: 2
  // },
  {
    id: 3,
    label: "Standard- 3 Star",
    value: 3,
  },
  {
    id: 4,
    label: "Premium- 4 Star",
    value: 4,
  },
  {
    id: 5,
    label: "Luxury- 5 Star",
    value: 5,
  },
];

export const CATEGORIES = [
  {
    id: 1,
    name: "India",
    url: "india",
    display_name: "India",
    icon_name: "india",
    parent: null,
    enabled: false,
  },
  {
    id: 2,
    name: "International",
    url: "international",
    display_name: "International",
    icon_name: "international",
    parent: null,
    enabled: false,
  },
  {
    id: 3,
    name: "Flights",
    url: "flight-inventory-slash-blocks",
    display_name: "Flight",
    icon_name: "flight_takeoff",
    parent: null,
    enabled: true,
  },
  {
    id: 5,
    name: "Package",
    url: "package",
    display_name: "Package",
    icon_name: "all_inclusive",
    parent: null,
    enabled: true,
  },
  {
    id: 4,
    name: "Hotels",
    url: "accommodation-hotel",
    display_name: "Hotel",
    icon_name: "hotel",
    parent: null,
    enabled: true,
  },
  {
    id: 6,
    name: "Visa",
    url: "visa",
    display_name: "Visa",
    icon_name: "bookmark_border",
    parent: null,
    enabled: true,
  },
  {
    id: 7,
    name: "Transfers",
    url: "cabs-slash-bus-slash-transfers",
    display_name: "Transfers",
    icon_name: "local_taxi",
    parent: null,
    enabled: true,
  },
  {
    id: 8,
    name: "Activities",
    url: "activities-slash-tours-slash-sightseeing",
    display_name: "Sightseeing",
    icon_name: "local_activity",
    parent: null,
    enabled: true,
  },
  {
    id: 9,
    name: "Fixed Departure", // Package
    url: "fixed-departure-package",
    display_name: "FD",
    icon_name: "card_travel",
    parent: 5,
    enabled: true,
  },
  {
    id: 10,
    name: "Customized", // Itinerary
    url: "standard-itinerary",
    display_name: "SI",
    icon_name: "check",
    parent: 5,
    enabled: true,
  },
  // {
  //     "id": 11,
  //     "name": "Cruises",
  //     "url": "cruises",
  //     "display_name": "Cruises",
  //     "icon_name": "check",
  //     "parent": null,
  //     "enabled": true
  // }
  {
    id: 12,
    name: "One way",
    url: "OW",
    display_name: "One way",
    icon_name: "check",
    parent: 3,
    enabled: true,
  },
  {
    id: 13,
    name: "Round trip",
    url: "RT",
    display_name: "Round trip",
    icon_name: "check",
    parent: 3,
    enabled: true,
  },
];

export const DESTINATIONS = [
  {
    id: 1,
    name: "Australia",
    type: "international",
  },
  {
    id: 2,
    name: "Bali",
    type: "international",
  },
  {
    id: 3,
    name: "Dubai",
    type: "international",
  },
  {
    id: 4,
    name: "Europe",
    type: "international",
  },
  {
    id: 5,
    name: "Hong Kong",
    type: "international",
  },
  {
    id: 6,
    name: "Malaysia",
    type: "international",
  },
  {
    id: 7,
    name: "Maldives",
    type: "international",
  },
  {
    id: 8,
    name: "Mauritius",
    type: "international",
  },
  {
    id: 9,
    name: "New Zealand",
    type: "international",
  },
  {
    id: 10,
    name: "Seychelles",
    type: "international",
  },
  {
    id: 11,
    name: "Singapore",
    type: "international",
  },
  {
    id: 12,
    name: "South Africa",
    type: "international",
  },
  {
    id: 13,
    name: "Sri Lanka",
    type: "international",
  },
  {
    id: 14,
    name: "Switzerland",
    type: "international",
  },
  {
    id: 15,
    name: "Thailand",
    type: "international",
  },
  {
    id: 16,
    name: "Turkey",
    type: "international",
  },
  {
    id: 17,
    name: "Singapore + Bali",
    type: "international",
  },
  {
    id: 18,
    name: "Singapore + Malaysia",
    type: "international",
  },
  {
    id: 19,
    name: "Others international",
    type: "international",
  },
  {
    id: 20,
    name: "Bhutan",
    type: "international",
  },
  {
    id: 21,
    name: "Africa",
    type: "international",
  },
  {
    id: 22,
    name: "Egypt",
    type: "international",
  },
  {
    id: 23,
    name: "Cambodia",
    type: "international",
  },
  {
    id: 24,
    name: "Vietnam",
    type: "international",
  },
  {
    id: 25,
    name: "Nepal",
    type: "international",
  },
  {
    id: 26,
    name: "CIS Countries ",
    type: "international",
  },
  {
    id: 27,
    name: "Iceland",
    type: "international",
  },
  {
    id: 28,
    name: "Kenya",
    type: "international",
  },
  {
    id: 29,
    name: "Azerbaijan",
    type: "international",
  },
  {
    id: 30,
    name: "Andaman",
    type: "india",
  },
  {
    id: 31,
    name: "Char Dham",
    type: "india",
  },
  {
    id: 32,
    name: "Goa",
    type: "india",
  },
  {
    id: 33,
    name: "Golden Triangle",
    type: "india",
  },
  {
    id: 34,
    name: "Kerala",
    type: "india",
  },
  {
    id: 35,
    name: "Ladakh",
    type: "india",
  },
  {
    id: 36,
    name: "North East",
    type: "india",
  },
  {
    id: 37,
    name: "Himachal",
    type: "india",
  },
  {
    id: 38,
    name: "Kashmir",
    type: "india",
  },
  {
    id: 39,
    name: "Rajasthan",
    type: "india",
  },
  {
    id: 40,
    name: "Sikkim - Darjeeling",
    type: "india",
  },
  {
    id: 41,
    name: "Bangalore",
    type: "india",
  },
  {
    id: 42,
    name: "Chennai",
    type: "india",
  },
  {
    id: 43,
    name: "Hyderabad",
    type: "india",
  },
  {
    id: 44,
    name: "Lucknow",
    type: "india",
  },
  {
    id: 45,
    name: "Mumbai",
    type: "india",
  },
  {
    id: 46,
    name: "New Delhi",
    type: "india",
  },
  {
    id: 47,
    name: "Pune",
    type: "india",
  },
  {
    id: 48,
    name: "Others",
    type: "india",
  },
  {
    id: 49,
    name: "Gujarat",
    type: "india",
  },
  {
    id: 50,
    name: "Uttarakhand",
    type: "india",
  },
  {
    id: 51,
    name: "Uttar Pradesh",
    type: "india",
  },
  {
    id: 52,
    name: "West Bengal",
    type: "india",
  },
  {
    id: 53,
    name: "Bihar",
    type: "india",
  },
  {
    id: 54,
    name: "Punjab",
    type: "india",
  },
  {
    id: 55,
    name: "Tamil Nadu",
    type: "india",
  },
  {
    id: 56,
    name: "Karnataka",
    type: "india",
  },
  {
    id: 57,
    name: "Odisha",
    type: "india",
  },
  {
    id: 58,
    name: "Maharashtra",
    type: "india",
  },
  {
    id: 59,
    name: "UAE",
    type: "international",
  },
  {
    id: 60,
    name: "China",
    type: "international",
  },
  {
    id: 61,
    name: "Japan",
    type: "international",
  },
  {
    id: 62,
    name: "Canada",
    type: "international",
  },
  {
    id: 63,
    name: "Israel",
    type: "international",
  },
  {
    id: 64,
    name: "USA",
    type: "international",
  },
  {
    id: 65,
    name: "Russia",
    type: "international",
  },
  {
    id: 66,
    name: "Myanmar",
    type: "international",
  },
  {
    id: 67,
    name: "Jordan",
    type: "international",
  },
  {
    id: 68,
    name: "Uzbekistan",
    type: "international",
  },
];

export const DESTINATIONS_INDIA = [
  {
    id: 30,
    name: "Andaman",
    type: "india",
  },
  {
    id: 31,
    name: "Char Dham",
    type: "india",
  },
  {
    id: 32,
    name: "Goa",
    type: "india",
  },
  {
    id: 33,
    name: "Golden Triangle",
    type: "india",
  },
  {
    id: 34,
    name: "Kerala",
    type: "india",
  },
  {
    id: 35,
    name: "Ladakh",
    type: "india",
  },
  {
    id: 36,
    name: "North East",
    type: "india",
  },
  {
    id: 37,
    name: "Himachal",
    type: "india",
  },
  {
    id: 38,
    name: "Kashmir",
    type: "india",
  },
  {
    id: 39,
    name: "Rajasthan",
    type: "india",
  },
  {
    id: 40,
    name: "Sikkim - Darjeeling",
    type: "india",
  },
  {
    id: 41,
    name: "Bangalore",
    type: "india",
  },
  {
    id: 42,
    name: "Chennai",
    type: "india",
  },
  {
    id: 43,
    name: "Hyderabad",
    type: "india",
  },
  {
    id: 44,
    name: "Lucknow",
    type: "india",
  },
  {
    id: 45,
    name: "Mumbai",
    type: "india",
  },
  {
    id: 46,
    name: "New Delhi",
    type: "india",
  },
  {
    id: 47,
    name: "Pune",
    type: "india",
  },
  {
    id: 48,
    name: "Others",
    type: "india",
  },
  {
    id: 49,
    name: "Gujarat",
    type: "india",
  },
  {
    id: 50,
    name: "Uttarakhand",
    type: "india",
  },
  {
    id: 51,
    name: "Uttar Pradesh",
    type: "india",
  },
  {
    id: 52,
    name: "West Bengal",
    type: "india",
  },
  {
    id: 53,
    name: "Bihar",
    type: "india",
  },
  {
    id: 54,
    name: "Punjab",
    type: "india",
  },
  {
    id: 55,
    name: "Tamil Nadu",
    type: "india",
  },
  {
    id: 56,
    name: "Karnataka",
    type: "india",
  },
  {
    id: 57,
    name: "Odisha",
    type: "india",
  },
  {
    id: 58,
    name: "Maharashtra",
    type: "india",
  },
];

export const DESTINATTIONS_INTERNATIONAL = [
  {
    id: 1,
    name: "Australia",
    type: "international",
  },
  {
    id: 2,
    name: "Bali",
    type: "international",
  },
  {
    id: 3,
    name: "Dubai",
    type: "international",
  },
  {
    id: 4,
    name: "Europe",
    type: "international",
  },
  {
    id: 5,
    name: "Hong Kong",
    type: "international",
  },
  {
    id: 6,
    name: "Malaysia",
    type: "international",
  },
  {
    id: 7,
    name: "Maldives",
    type: "international",
  },
  {
    id: 8,
    name: "Mauritius",
    type: "international",
  },
  {
    id: 9,
    name: "New Zealand",
    type: "international",
  },
  {
    id: 10,
    name: "Seychelles",
    type: "international",
  },
  {
    id: 11,
    name: "Singapore",
    type: "international",
  },
  {
    id: 12,
    name: "South Africa",
    type: "international",
  },
  {
    id: 13,
    name: "Sri Lanka",
    type: "international",
  },
  {
    id: 14,
    name: "Switzerland",
    type: "international",
  },
  {
    id: 15,
    name: "Thailand",
    type: "international",
  },
  {
    id: 16,
    name: "Turkey",
    type: "international",
  },
  {
    id: 17,
    name: "Singapore + Bali",
    type: "international",
  },
  {
    id: 18,
    name: "Singapore + Malaysia",
    type: "international",
  },
  {
    id: 19,
    name: "Others international",
    type: "international",
  },
  {
    id: 20,
    name: "Bhutan",
    type: "international",
  },
  {
    id: 21,
    name: "Africa",
    type: "international",
  },
  {
    id: 22,
    name: "Egypt",
    type: "international",
  },
  {
    id: 23,
    name: "Cambodia",
    type: "international",
  },
  {
    id: 24,
    name: "Vietnam",
    type: "international",
  },
  {
    id: 25,
    name: "Nepal",
    type: "international",
  },
  {
    id: 26,
    name: "CIS Countries ",
    type: "international",
  },
  {
    id: 27,
    name: "Iceland",
    type: "international",
  },
  {
    id: 28,
    name: "Kenya",
    type: "international",
  },
  {
    id: 29,
    name: "Azerbaijan",
    type: "international",
  },
  {
    id: 59,
    name: "UAE",
    type: "international",
  },
  {
    id: 60,
    name: "China",
    type: "international",
  },
  {
    id: 61,
    name: "Japan",
    type: "international",
  },
  {
    id: 62,
    name: "Canada",
    type: "international",
  },
  {
    id: 63,
    name: "Israel",
    type: "international",
  },
  {
    id: 64,
    name: "USA",
    type: "international",
  },
  {
    id: 65,
    name: "Russia",
    type: "international",
  },
  {
    id: 66,
    name: "Myanmar",
    type: "international",
  },
  {
    id: 67,
    name: "Jordan",
    type: "international",
  },
  {
    id: 68,
    name: "Uzbekistan",
    type: "international",
  },
];

export const CATEGORY_INDIA = 1;
export const CATEGORY_INTERNATIONAL = 2;
export const CATEGORY_FLIGHT = 3;
export const CATEGORY_ACCOMODATION = 4;
export const CATEGORY_PACKAGE = 5;
export const CATEGORY_VISA = 6;
export const CATEGORY_CABS_TRANSFER = 7;
export const CATEGORY_ACTIVITIES = 8;
export const CATEGORY_FIXED_DEPARTURE = 9;
export const CATEGORY_STANDARD_ITINERARY = 10;
export const CATEGORY_CRUISE = 11;
export const CATEGORY_CHILD_ONE_WAY = 12;
export const CATEGORY_CHILD_ROUND_TRIP = 13;

export const FLIGHT_CHILD_ONE_WAY = "OW";
export const FLIGHT_CHILD_ROUND_TRIP = "RT";
export const PACKAGE_CHILD_STANDARD = "standard-itinerary";
export const PACKAGE_CHILD_FIXED = "fixed-departure-package";
export const OTHER_CATEGORY_DOMESTIC = "domestic";
export const OTHER_CATEGORY_INTERNATIONAL = "international";

export const monthNames = [
  "Jan",
  "Feb",
  "Mar",
  "Apr",
  "May",
  "Jun",
  "Jul",
  "Aug",
  "Sep",
  "Oct",
  "Nov",
  "Dec",
];

export const COUNTRY = [
  {
    name: "India",
    dial_code: "+91",
    code: "IN",
    label: "India +91",
    value: "+91",
  },
  {
    name: "Australia",
    dial_code: "+61",
    code: "AU",
    label: "Australia +61",
    value: "+61",
  },
  {
    name: "Austria",
    dial_code: "+43",
    code: "AT",
    label: "Austria +43",
    value: "+43",
  },
  {
    name: "Azerbaijan",
    dial_code: "+994",
    code: "AZ",
    label: "Azerbaijan +994",
    value: "+994",
  },
  {
    name: "Bahamas",
    dial_code: "+1 242",
    code: "BS",
    label: "Bahamas +1 242",
    value: "+1 242",
  },
  {
    name: "Bahrain",
    dial_code: "+973",
    code: "BH",
    label: "Bahrain +973",
    value: "+973",
  },
  {
    name: "Bangladesh",
    dial_code: "+880",
    code: "BD",
    label: "Bangladesh +880",
    value: "+880",
  },
  {
    name: "Barbados",
    dial_code: "+1 246",
    code: "BB",
    label: "Barbados +1 246",
    value: "+1 246",
  },
  {
    name: "Belarus",
    dial_code: "+375",
    code: "BY",
    label: "Belarus +375",
    value: "+375",
  },
  {
    name: "Belgium",
    dial_code: "+32",
    code: "BE",
    label: "Belgium +32",
    value: "+32",
  },
  {
    name: "Belize",
    dial_code: "+501",
    code: "BZ",
    label: "Belize +501",
    value: "+501",
  },
  {
    name: "Benin",
    dial_code: "+229",
    code: "BJ",
    label: "Benin +229",
    value: "+229",
  },
  {
    name: "Bermuda",
    dial_code: "+1 441",
    code: "BM",
    label: "Bermuda +1 441",
    value: "+1 441",
  },
  {
    name: "Bhutan",
    dial_code: "+975",
    code: "BT",
    label: "Bhutan +975",
    value: "+975",
  },
  {
    name: "Bolivia",
    dial_code: "+591",
    code: "BO",
    label: "Bolivia +591",
    value: "+591",
  },
  {
    name: "Bosnia and HZ",
    dial_code: "+387",
    code: "BA",
    label: "Bosnia and HZ +387",
    value: "+387",
  },
  {
    name: "Botswana",
    dial_code: "+267",
    code: "BW",
    label: "Botswana +267",
    value: "+267",
  },
  {
    name: "Brazil",
    dial_code: "+55",
    code: "BR",
    label: "Brazil +55",
    value: "+55",
  },
  {
    name: "Bulgaria",
    dial_code: "+359",
    code: "BG",
    label: "Bulgaria +359",
    value: "+359",
  },
  {
    name: "Cambodia",
    dial_code: "+855",
    code: "KH",
    label: "Cambodia +855",
    value: "+855",
  },
  {
    name: "Canada",
    dial_code: "+1",
    code: "CA",
    label: "Canada +1",
    value: " +1",
  },
  {
    name: "China",
    dial_code: "+86",
    code: "CN",
    label: "China +86",
    value: "+86",
  },
  {
    name: "Colombia",
    dial_code: "+57",
    code: "CO",
    label: "Colombia +57",
    value: "+57",
  },
  {
    name: "Croatia",
    dial_code: "+385",
    code: "HR",
    label: "Croatia +385",
    value: "+385",
  },
  {
    name: "Cuba",
    dial_code: "+53",
    code: "CU",
    label: "Cuba +53",
    value: "+53",
  },
  {
    name: "Cyprus",
    dial_code: "+537",
    code: "CY",
    label: "Cyprus +537",
    value: "+537",
  },
  {
    name: "Czech Republic",
    dial_code: "+420",
    code: "CZ",
    label: "Czech Republic +420",
    value: "+420",
  },
  {
    name: "Denmark",
    dial_code: "+45",
    code: "DK",
    label: "Denmark +45",
    value: "+45",
  },
  {
    name: "Ecuador",
    dial_code: "+593",
    code: "EC",
    label: "Ecuador +593",
    value: "+593",
  },
  {
    name: "Egypt",
    dial_code: "+20",
    code: "EG",
    label: "Egypt +20",
    value: "+20",
  },
  {
    name: "Ethiopia",
    dial_code: "+251",
    code: "ET",
    label: "Ethiopia +251",
    value: "+251",
  },
  {
    name: "Finland",
    dial_code: "+358",
    code: "FI",
    label: "Finland +358",
    value: "+358",
  },
  {
    name: "France",
    dial_code: "+33",
    code: "FR",
    label: "France +33",
    value: "+33",
  },
  {
    name: "Germany",
    dial_code: "+49",
    code: "DE",
    label: "Germany +49",
    value: "+49",
  },
  {
    name: "Greece",
    dial_code: "+30",
    code: "GR",
    label: "Greece +30",
    value: "+30",
  },
  {
    name: "Greenland",
    dial_code: "+299",
    code: "GL",
    label: "Greenland +299",
    value: "+299",
  },
  {
    name: "Honduras",
    dial_code: "+504",
    code: "HN",
    label: "Honduras +504",
    value: "+504",
  },
  {
    name: "Hong Kong",
    dial_code: "+852",
    code: "HK",
    label: "Hong Kong +852",
    value: "+852",
  },
  {
    name: "Hungary",
    dial_code: "+36",
    code: "HU",
    label: "Hungary +36",
    value: "+36",
  },
  {
    name: "Iceland",
    dial_code: "+354",
    code: "IS",
    label: "Iceland +354",
    value: "+354",
  },
  {
    name: "India",
    dial_code: "+91",
    code: "IN",
    label: "India +91",
    value: "+91",
  },
  {
    name: "Indonesia",
    dial_code: "+62",
    code: "ID",
    label: "Indonesia +62",
    value: "+62",
  },
  {
    name: "Iran",
    dial_code: "+98",
    code: "IR",
    label: "Iran +98",
    value: "+98",
  },
  {
    name: "Iraq",
    dial_code: "+964",
    code: "IQ",
    label: "Iraq +964",
    value: "+964",
  },
  {
    name: "Ireland",
    dial_code: "+353",
    code: "IE",
    label: "Ireland +353",
    value: "+353",
  },
  {
    name: "Isle of Man",
    dial_code: "+44",
    code: "IM",
    label: "Isle of Man +44",
    value: "+44",
  },
  {
    name: "Israel",
    dial_code: "+972",
    code: "IL",
    label: "Israel +972",
    value: "+972",
  },
  {
    name: "Italy",
    dial_code: "+39",
    code: "IT",
    label: "Italy +39",
    value: "+39",
  },
  {
    name: "Jamaica",
    dial_code: "+1 876",
    code: "JM",
    label: "Jamaica +1 876",
    value: "+1 876",
  },
  {
    name: "Japan",
    dial_code: "+81",
    code: "JP",
    label: "Japan +81",
    value: "+81",
  },
  {
    name: "Jersey",
    dial_code: "+44",
    code: "JE",
    label: "Jersey +44",
    value: "+44",
  },
  {
    name: "Jordan",
    dial_code: "+962",
    code: "JO",
    label: "Jordan +962",
    value: "+962",
  },
  {
    name: "Kazakhstan",
    dial_code: "+7 7",
    code: "KZ",
    label: "Kazakhstan +7 7",
    value: "+7 7",
  },
  {
    name: "Kenya",
    dial_code: "+254",
    code: "KE",
    label: "Kenya +254",
    value: "+254",
  },
  {
    name: "Kuwait",
    dial_code: "+965",
    code: "KW",
    label: "Kuwait +965",
    value: "+965",
  },
  {
    name: "Kyrgyzstan",
    dial_code: "+996",
    code: "KG",
    label: "Kyrgyzstan +996",
    value: "+996",
  },
  {
    name: "Latvia",
    dial_code: "+371",
    code: "LV",
    label: "Latvia +371",
    value: "+371",
  },
  {
    name: "Lebanon",
    dial_code: "+961",
    code: "LB",
    label: "Lebanon +961",
    value: "+961",
  },
  {
    name: "Liberia",
    dial_code: "+231",
    code: "LR",
    label: "Liberia +231",
    value: "+231",
  },
  {
    name: "Liechtenstein",
    dial_code: "+423",
    code: "LI",
    label: "Liechtenstein +423",
    value: "+423",
  },
  {
    name: "Lithuania",
    dial_code: "+370",
    code: "LT",
    label: "Lithuania +370",
    value: "+370",
  },
  {
    name: "Luxembourg",
    dial_code: "+352",
    code: "LU",
    label: "Luxembourg +352",
    value: "+352",
  },
  {
    name: "Macao",
    dial_code: "+853",
    code: "MO",
    label: "Macao +853",
    value: "+853",
  },
  {
    name: "Macedonia",
    dial_code: "+389",
    code: "MK",
    label: "Macedonia +389",
    value: "+389",
  },
  {
    name: "Madagascar",
    dial_code: "+261",
    code: "MG",
    label: "Madagascar +261",
    value: "+261",
  },
  {
    name: "Malawi",
    dial_code: "+265",
    code: "MW",
    label: "Malawi +265",
    value: "+265",
  },
  {
    name: "Malaysia",
    dial_code: "+60",
    code: "MY",
    label: "Malaysia +60",
    value: "+60",
  },
  {
    name: "Maldives",
    dial_code: "+960",
    code: "MV",
    label: "Maldives +960",
    value: "+960",
  },
  {
    name: "Mali",
    dial_code: "+223",
    code: "ML",
    label: "Mali +223",
    value: "+223",
  },
  {
    name: "Malta",
    dial_code: "+356",
    code: "MT",
    label: "Malta +356",
    value: "+356",
  },
  {
    name: "Mauritius",
    dial_code: "+230",
    code: "MU",
    label: "Mauritius +230",
    value: "+230",
  },
  {
    name: "Mexico",
    dial_code: "+52",
    code: "MX",
    label: "Mexico +52",
    value: "+52",
  },
  {
    name: "Mongolia",
    dial_code: "+976",
    code: "MN",
    label: "Mongolia +976",
    value: "+976",
  },
  {
    name: "Montenegro",
    dial_code: "+382",
    code: "ME",
    label: "Montenegro +382",
    value: "+382",
  },
  {
    name: "Morocco",
    dial_code: "+212",
    code: "MA",
    label: "Morocco +212",
    value: "+212",
  },
  {
    name: "Mozambique",
    dial_code: "+258",
    code: "MZ",
    label: "Mozambique +258",
    value: "+258",
  },
  {
    name: "Myanmar",
    dial_code: "+95",
    code: "MM",
    label: "Myanmar +95",
    value: "+95",
  },
  {
    name: "Namibia",
    dial_code: "+264",
    code: "NA",
    label: "Namibia +264",
    value: "+264",
  },
  {
    name: "Nauru",
    dial_code: "+674",
    code: "NR",
    label: "Nauru +674",
    value: "+674",
  },
  {
    name: "Nepal",
    dial_code: "+977",
    code: "NP",
    label: "Nepal +977",
    value: "+977",
  },
  {
    name: "Netherlands",
    dial_code: "+31",
    code: "NL",
    label: "Netherlands +31",
    value: "+31",
  },
  {
    name: "New Zealand",
    dial_code: "+64",
    code: "NZ",
    label: "New Zealand +64",
    value: "+64",
  },
  {
    name: "Nicaragua",
    dial_code: "+505",
    code: "NI",
    label: "Nicaragua +505",
    value: "+505",
  },
  {
    name: "Niger",
    dial_code: "+227",
    code: "NE",
    label: "Niger +227",
    value: "+227",
  },
  {
    name: "Nigeria",
    dial_code: "+234",
    code: "NG",
    label: "Nigeria +234",
    value: "+234",
  },
  {
    name: "Niue",
    dial_code: "+683",
    code: "NU",
    label: "Niue +683",
    value: "+683",
  },
  {
    name: "Norfolk Island",
    dial_code: "+672",
    code: "NF",
    label: "Norfolk Island +672",
    value: "+672",
  },
  {
    name: "Norway",
    dial_code: "+47",
    code: "NO",
    label: "Norway +47",
    value: "+47",
  },
  {
    name: "Oman",
    dial_code: "+968",
    code: "OM",
    label: "Oman +968",
    value: "+968",
  },
  {
    name: "Pakistan",
    dial_code: "+92",
    code: "PK",
    label: "Pakistan +92",
    value: "+92",
  },
  {
    name: "Palau",
    dial_code: "+680",
    code: "PW",
    label: "Palau +680",
    value: "+680",
  },
  {
    name: "Panama",
    dial_code: "+507",
    code: "PA",
    label: "Panama +507",
    value: "+507",
  },
  {
    name: "Papua New Guinea",
    dial_code: "+675",
    code: "PG",
    label: "Papua New Guinea +675",
    value: "+675",
  },
  {
    name: "Paraguay",
    dial_code: "+595",
    code: "PY",
    label: "Paraguay +595",
    value: "+595",
  },
  {
    name: "Peru",
    dial_code: "+51",
    code: "PE",
    label: "Peru +51",
    value: "+51",
  },
  {
    name: "Philippines",
    dial_code: "+63",
    code: "PH",
    label: "Philippines +63",
    value: "+63",
  },
  {
    name: "Pitcairn",
    dial_code: "+872",
    code: "PN",
    label: "Pitcairn +872",
    value: "+872",
  },
  {
    name: "Poland",
    dial_code: "+48",
    code: "PL",
    label: "Poland +48",
    value: "+48",
  },
  {
    name: "Portugal",
    dial_code: "+351",
    code: "PT",
    label: "Portugal +351",
    value: "+351",
  },
  {
    name: "Puerto Rico",
    dial_code: "+1 939",
    code: "PR",
    label: "Puerto Rico +1 939",
    value: "+1 939",
  },
  {
    name: "Qatar",
    dial_code: "+974",
    code: "QA",
    label: "Qatar +974",
    value: "+974",
  },
  {
    name: "Romania",
    dial_code: "+40",
    code: "RO",
    label: "Romania +40",
    value: "+40",
  },
  {
    name: "Russia",
    dial_code: "+7",
    code: "RU",
    label: "Russia +7",
    value: "+7",
  },
  {
    name: "Rwanda",
    dial_code: "+250",
    code: "RW",
    label: "Rwanda +250",
    value: "+250",
  },
  {
    name: "Réunion",
    dial_code: "+262",
    code: "RE",
    label: "Réunion +262",
    value: "+262",
  },
  {
    name: "Saudi Arabia",
    dial_code: "+966",
    code: "SA",
    label: "Saudi Arabia +966",
    value: "+966",
  },
  {
    name: "Serbia",
    dial_code: "+381",
    code: "RS",
    label: "Serbia +381",
    value: "+381",
  },
  {
    name: "Seychelles",
    dial_code: "+248",
    code: "SC",
    label: "Seychelles +248",
    value: "+248",
  },
  {
    name: "Sierra Leone",
    dial_code: "+232",
    code: "SL",
    label: "Sierra Leone +232",
    value: "+232",
  },
  {
    name: "Singapore",
    dial_code: "+65",
    code: "SG",
    label: "Singapore +65",
    value: "+65",
  },
  {
    name: "Slovakia",
    dial_code: "+421",
    code: "SK",
    label: "Slovakia +421",
    value: "+421",
  },
  {
    name: "Slovenia",
    dial_code: "+386",
    code: "SI",
    label: "Slovenia +386",
    value: "+386",
  },
  {
    name: "Solomon Islands",
    dial_code: "+677",
    code: "SB",
    label: "Solomon Islands +677",
    value: "+677",
  },
  {
    name: "Somalia",
    dial_code: "+252",
    code: "SO",
    label: "Somalia +252",
    value: "+252",
  },
  {
    name: "South Africa",
    dial_code: "+27",
    code: "ZA",
    label: "South Africa +27",
    value: "+27",
  },
  {
    name: "Spain",
    dial_code: "+34",
    code: "ES",
    label: "Spain +34",
    value: "+34",
  },
  {
    name: "Sri Lanka",
    dial_code: "+94",
    code: "LK",
    label: "Sri Lanka +94",
    value: "+94",
  },
  {
    name: "Sudan",
    dial_code: "+249",
    code: "SD",
    label: "Sudan +249",
    value: "+249",
  },
  {
    name: "Sweden",
    dial_code: "+46",
    code: "SE",
    label: "Sweden +46",
    value: "+46",
  },
  {
    name: "Switzerland",
    dial_code: "+41",
    code: "CH",
    label: "Switzerland +41",
    value: "+41",
  },
  {
    name: "Syrian ",
    dial_code: "+963",
    code: "SY",
    label: "Syrian  +963",
    value: "+963",
  },
  {
    name: "Taiwan",
    dial_code: "+886",
    code: "TW",
    label: "Taiwan +886",
    value: "+886",
  },
  {
    name: "Tajikistan",
    dial_code: "+992",
    code: "TJ",
    label: "Tajikistan +992",
    value: "+992",
  },
  {
    name: "Tanzania",
    dial_code: "+255",
    code: "TZ",
    label: "Tanzania +255",
    value: "+255",
  },
  {
    name: "Thailand",
    dial_code: "+66",
    code: "TH",
    label: "Thailand +66",
    value: "+66",
  },
  {
    name: "Timor-Leste",
    dial_code: "+670",
    code: "TL",
    label: "Timor-Leste +670",
    value: "+670",
  },
  {
    name: "Togo",
    dial_code: "+228",
    code: "TG",
    label: "Togo +228",
    value: "+228",
  },
  {
    name: "Tokelau",
    dial_code: "+690",
    code: "TK",
    label: "Tokelau +690",
    value: "+690",
  },
  {
    name: "Tonga",
    dial_code: "+676",
    code: "TO",
    label: "Tonga +676",
    value: "+676",
  },
  {
    name: "Trinidad",
    dial_code: "+1 868",
    code: "TT",
    label: "Trinidad +1 868",
    value: "+1 868",
  },
  {
    name: "Tunisia",
    dial_code: "+216",
    code: "TN",
    label: "Tunisia +216",
    value: "+216",
  },
  {
    name: "Turkey",
    dial_code: "+90",
    code: "TR",
    label: "Turkey +90",
    value: "+90",
  },
  {
    name: "Turkmenistan",
    dial_code: "+993",
    code: "TM",
    label: "Turkmenistan +993",
    value: "+993",
  },
  {
    name: "Uganda",
    dial_code: "+256",
    code: "UG",
    label: "Uganda +256",
    value: "+256",
  },
  {
    name: "Ukraine",
    dial_code: "+380",
    code: "UA",
    label: "Ukraine +380",
    value: "+380",
  },
  {
    name: "UAE",
    dial_code: "+971",
    code: "AE",
    label: "UAE +971",
    value: "+971",
  },
  {
    name: "United Kingdom",
    dial_code: "+44",
    code: "GB",
    label: "United Kingdom +44",
    value: "+44",
  },
  {
    name: "United States",
    dial_code: "+1",
    code: "US",
    label: "United States +1",
    value: "+1",
  },
  {
    name: "Uruguay",
    dial_code: "+598",
    code: "UY",
    label: "Uruguay +598",
    value: "+598",
  },
  {
    name: "Uzbekistan",
    dial_code: "+998",
    code: "UZ",
    label: "Uzbekistan +998",
    value: "+998",
  },
  {
    name: "Vanuatu",
    dial_code: "+678",
    code: "VU",
    label: "Vanuatu +678",
    value: "+678",
  },
  {
    name: "Venezuela",
    dial_code: "+58",
    code: "VE",
    label: "Venezuela +58",
    value: "+58",
  },
  {
    name: "Vietnam",
    dial_code: "+84",
    code: "VN",
    label: "Vietnam +84",
    value: "+84",
  },
  {
    name: "Virgin Islands",
    dial_code: "+1 284",
    code: "VG",
    label: "Virgin Islands +1 284",
    value: "+1 284",
  },
  {
    name: "Yemen",
    dial_code: "+967",
    code: "YE",
    label: "Yemen +967",
    value: "+967",
  },
  {
    name: "Zambia",
    dial_code: "+260",
    code: "ZM",
    label: "Zambia +260",
    value: "+260",
  },
  {
    name: "Zimbabwe",
    dial_code: "+263",
    code: "ZW",
    label: "Zimbabwe +263",
    value: "+263",
  },
];

export const starOptions = [3, 4, 5].map((n) => ({
  value: n,
  label: `${n} Star`,
}));

export const HOTEL_STAR_OPTIONS = [
  {
    id: 1,
    label: "Unrated",
    value: 1,
  },
  {
    id: 2,
    label: "2 Star",
    value: 2,
  },
  {
    id: 3,
    label: "3 Star",
    value: 3,
  },
  {
    id: 4,
    label: "4 Star",
    value: 4,
  },
  {
    id: 5,
    label: "5 Star",
    value: 5,
  },
];

export const LOCAL_START = process.env.REACT_APP_LOCAL_START === "true";
export const LEO_TEMPLATE_START = process.env.REACT_APP_LEO_START === "true";
export const REDIRECT_301 = process.env.REACT_APP_REDIRECT_301 === "true";

export const LOCAL_STORAGE_THEME_KEY = "b2b2cTheme";

export const B2B2C_LOCALSTORAGE_KEY = "b2b2cUser";

export const NAVBAR_EXTERNAL_LINKS = ["packages"];
export const redirectionPowered = "https://www.travclan.com/";
